const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/de.json'));
module.exports = countries.getNames('de', {select: 'official'});
